module.exports = __webpack_public_path__ + "img/DAVID_CANNON_38-rs.551e6fef.jpg";